/**
 * CUSTOM: Expanded size selectors
 * Added: 2026-10-08
 * Description: Shows the clicked size's price per 100 ml in the option label row straight away, read from the
 * input's data-unit-price, instead of waiting for the variant picker's section re-render.
 */
import { Component } from '@theme/component';

class SizeUnitPrice extends Component {
  /** @type {HTMLFieldSetElement | null} */
  #fieldset = null;

  connectedCallback() {
    super.connectedCallback();
    this.#fieldset = this.closest('fieldset');
    this.#fieldset?.addEventListener('change', this.#onChange);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#fieldset?.removeEventListener('change', this.#onChange);
    this.#fieldset = null;
  }

  /** @param {Event} event */
  #onChange = (event) => {
    if (!(event.target instanceof HTMLInputElement)) return;

    const { unitPrice } = event.target.dataset;
    if (unitPrice !== undefined) this.textContent = unitPrice;
  };
}

if (!customElements.get('size-unit-price')) customElements.define('size-unit-price', SizeUnitPrice);
